import React, { useCallback, useState, useRef } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
//import doc from "../../c4611_sample_explain.pdf";
import 'react-pdf/dist/Page/TextLayer.css';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import { Button, Grid } from '@mui/material';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const maxWidth = 800;
const options = {
  cMapUrl: '/cmaps/',
  standardFontDataUrl: '/standard_fonts/',
};

const Pdf = () => {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [selectedText, setSelectedText] = useState('');

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  function changePage(offset) {
    setPageNumber(prevPageNumber => prevPageNumber + offset);
  }

  function previousPage() {
    changePage(-1);
  }

  function nextPage() {
    changePage(1);
  }

  const handleTextSelection = useCallback(() => {
    const selection = window.getSelection();
    const selectedText = selection.toString();
    setSelectedText(selectedText);
  }, []);

  return (
    <>
    <Grid container sx={{display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        paddingTop: "2rem",
        color: "primary.main",}}>
      <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
        <Document
          file={doc}
          onLoadSuccess={onDocumentLoadSuccess}
          options={options}
        >
          <Page pageNumber={pageNumber} renderTextLayer={true} />
        </Document>
      </Grid>
      <Grid item>
        <Button type="button" disabled={pageNumber <= 1} onClick={previousPage}>
          Previous
        </Button>
      </Grid>
      <Grid item>
        <Button type="button" disabled={pageNumber >= numPages} onClick={nextPage}>
          Next
        </Button>
      </Grid>
      <Grid item>
        <Button type="button" onClick={handleTextSelection}>
          Mark
        </Button>
        </Grid>
      <p>{selectedText}</p>
      </Grid>
      </>
  );
};

export default Pdf;